import { render, staticRenderFns } from "./Busqueda.vue?vue&type=template&id=39b45624&scoped=true&"
import script from "./Busqueda.vue?vue&type=script&lang=js&"
export * from "./Busqueda.vue?vue&type=script&lang=js&"
import style0 from "./Busqueda.vue?vue&type=style&index=0&id=39b45624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b45624",
  null
  
)

export default component.exports